
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Wrench, Square, RectangleHorizontal, ShoppingCart, Truck, Construction, Sun } from 'lucide-react';

const iconMap = {
  Windshield: Wrench,
  Square: Square,
  RectangleHorizontal: RectangleHorizontal,
  ShoppingCart: ShoppingCart,
  Truck: Truck,
  Construction: Construction,
  Sun: Sun,
  Wrench: Wrench
};

function ServiceCard({ service, showDetails = true }) {
  const Icon = iconMap[service.icon] || Wrench;

  return (
    <div className="glass-card rounded-2xl p-8 flex flex-col h-full group">
      <div className="flex-1">
        <div className="w-16 h-16 rounded-2xl bg-[#003D7A]/20 flex items-center justify-center mb-6 transition-all duration-500 group-hover:bg-[#003D7A] group-hover:shadow-[0_0_20px_rgba(0,61,122,0.6)]">
          <Icon className="w-8 h-8 text-[#003D7A] group-hover:text-white transition-colors duration-500" />
        </div>
        <h3 className="text-2xl font-bold mb-4 text-white tracking-wide group-hover:text-blue-100 transition-colors duration-300 text-balance">
          {service.title}
        </h3>
        <p className="text-white/70 leading-relaxed text-lg mb-6">
          {service.description}
        </p>
      </div>
      
      {showDetails && (
        <div className="mt-auto pt-6 border-t border-white/10">
          <Link 
            to={`/services/${service.id}`}
            className="inline-flex items-center text-white font-medium hover:text-[#003D7A] transition-colors duration-300 group/link"
          >
            Детальніше
            <ArrowRight className="w-5 h-5 ml-2 transform group-hover/link:translate-x-2 transition-transform duration-300" />
          </Link>
        </div>
      )}
    </div>
  );
}

export default ServiceCard;
